import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  imageSrc: string;
  description: string;
}

export const TileSubscriptionPaywall: React.FC<Props> = ({
  imageSrc,
  description,
}) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-1 gap-4 px-7 pt-[14px] md:flex-col md:justify-between md:gap-8 md:px-6 md:pt-[26px]">
      <div className="flex min-w-0 flex-1 flex-col gap-2">
        <h3 className="text-headline-20 text-foreground md:text-title-24">
          {t('home.dashboard.subscriptionTitle')}
        </h3>
        <p className="text-body-13 text-muted-foreground max-md:truncate md:text-body-14">
          {description}
        </p>
      </div>
      <div className="relative mr-[-19px] mb-[-30px] w-[130px] shrink-0 self-end md:bottom-0 md:mr-[-8px] md:mb-0 md:ml-auto md:w-[170px]">
        <div
          aria-hidden
          className="bg-info-surface/85 absolute -inset-2 rounded-[18px] blur-[25px]"
        />
        <img
          src={imageSrc}
          alt=""
          className="relative block size-full object-cover object-top"
        />
      </div>
    </div>
  );
};
